import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { AdManagementService } from 'src/app/services/ad-management/ad-management.service';
import { CachingService } from 'src/app/services/caching/caching.service';
import { ToastrService } from 'ngx-toastr';
import { Notification } from 'src/app/models/notification';
import { Ad } from 'src/app/models/ad';
import { environment } from 'src/environments/environment';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-ad-detail',
  templateUrl: './ad-detail.component.html',
  styleUrls: ['./ad-detail.component.css'],
  providers: [AdManagementService, CachingService, ToastrService]
})
export class AdDetailComponent implements OnInit {
  ad: Ad;
  mail: string;
  phone: string;
  message: string;
  photoAssetsBaseUrl: string;

  constructor(
    private adManagementService: AdManagementService,
    private cachingService: CachingService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
  ) {
    this.photoAssetsBaseUrl = environment.photoAssetsBaseUrl;
  }

  ngOnInit(): void {
    this.route
      .paramMap
      .pipe(
        switchMap(
          (params: ParamMap) =>
            this.adManagementService.getPublicAd(params.get('id'))))
      .subscribe(
        ad => this.ad = ad);
  }

  // TODO: refactor this in another component
  sendNotification(title: string) {
    this.setCache();
    this.adManagementService
      .postNotification(
        new Notification(title, this.mail, this.phone, this.message))
      .subscribe(_ =>
        this.toastr.success('Notification envoyée'));
  }

  public getCache() {
    this.mail = this.cachingService.getMail();
    this.phone = this.cachingService.getPhone();
    this.message = this.cachingService.getMessage();
  }

  public setCache() {
    this.cachingService.setMail(this.mail);
    this.cachingService.setPhone(this.phone);
    this.cachingService.setMessage(this.message);
  }
}
